{{>TrajectoryStyleInfoPanelPositionsTpl}}
{{>TrajectoryStyleInfoPanelTrajectoryTpl}}
{{>TrajectoryStyleInfoPanelEstimationTpl}}
{{>TrajectoryStyleInfoPanelBreakrouteTpl}}
{{>TrajectoryStyleInfoPanelMobileSymbolTpl}}
{{>TrajectoryStyleInfoPanelMobileColorTpl}}
{{>MobileTrajectoryTpl}}
